import { createStore } from 'vuex'
import axiosInstance from '../../services/http/axios-instance'
import * as at from './const/actions-types'
import i18n from '../lang/i18n'
import { UserApi } from '@js-app/office/api/user-api'
import { ExportApi } from '@js-app/office/api/export-api'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import { downloadBlob } from '@js-app/services/helpers/download'
import { SET_XPAY_OPERATION_ID } from './const/actions-types'
//import { createAuthorizer } from '@js-app/services/helpers/authorizer-helper'
//const authorizer = createAuthorizer()

import authorizer from '@js-app/services/helpers/authorizer-instance'

const selectedLocale = localStorage.getItem('selectedLocale') || 'en'
const sidebarPinnedStored = localStorage.getItem('sidebar:pinned')

export default createStore({
  state: {
    showCabinetBottomNotice: true,
    user: {
      accessToken: '',
      refreshToken: '',
      isLoggedIn: false,
      data: {},
    },
    appState: {
      resetPasswordState: null,
    },
    selectedLocale,
    selectedCompany: null,
    selectedCompanyLoading: false,
    selectedCompanyData: {},
    activeExports: [],
    wss: null,
    subscribedWssChannels: [],
    isRulesLoaded: false,
    rulesLoadedForCompany: null,
    sidebar: {
      pinned: sidebarPinnedStored ? JSON.parse(sidebarPinnedStored) : false,
    },
    showFilters: false,
    xpayOperationId: '',
    xpayOperationType: '',
    companies: [],
    companiesLoaded: false,
  },
  getters: {
    canSeeCabinetNotices: (state) => {
      const opt =
          (state.user?.data?.OptionalParams || state.user?.data?.optionalParams || {});
      return opt.EnableCabinetNotices === true;
    },
    isUserLoggedIn: (state) => state.user.isLoggedIn,
    userData: (state) => state.user.data,
    exportExisted: (state) => {
      return (exportSection, filterString) => {
        return (
          state.activeExports.findIndex(
            (_export) =>
              _export.section === exportSection &&
              _export.filterString === filterString
          ) > -1
        )
      }
    },
    exportByUUID: (state) => (exportUUID) => {
      return state.activeExports.find(
        (_export) => _export.report_uuid === exportUUID
      )
    },
    rulesLoaded: (state) => (companyId) => {
      return (
        parseInt(state.rulesLoadedForCompany) === parseInt(companyId) &&
        state.isRulesLoaded
      )
    },
    companyLoaded: (state) => (companyId) => {
      return (
        parseInt(state.rulesLoadedForCompany) === parseInt(companyId) &&
        parseInt(state.selectedCompany) === parseInt(companyId)
      )
    },
  },
  mutations: {
    [at.SET_XPAY_OPERATION_TYPE](state, value) {
      state.xpayOperationType = value
    },
    [at.SET_XPAY_OPERATION_ID](state, value) {
      state.xpayOperationId = value
    },
    [at.SET_SHOW_FILTERS](state, value) {
      state.showFilters = value
    },
    [at.CHANGE_SIDEBAR_PINNED](state, isPinned) {
      state.sidebar.pinned = !!isPinned
      localStorage.setItem('sidebar:pinned', JSON.stringify(state.sidebar.pinned))
    },
    [at.LOGIN_USER](state, payload) {
      state.user.accessToken = payload.accessToken
      state.user.refreshToken = payload.refreshToken
      state.user.isLoggedIn = true
    },
    [at.UPDATE_TOKENS](state, tokens) {
      state.user.accessToken = tokens.accessToken
      state.user.refreshToken = tokens.refreshToken
    },
    [at.LOGOUT_USER](state) {
      state.user.accessToken = null
      state.user.refreshToken = null
      state.user.isLoggedIn = false
    },
    [at.SET_CURRENT_LOCALE](state, locale) {
      state.selectedLocale = locale
      i18n.global.locale = state.selectedLocale
    },
    [at.SET_ACTIVE_COMPANY](state, selectedCompanyId) {
      state.selectedCompany = selectedCompanyId
    },
    [at.SET_ACTIVE_COMPANY_DATA](state, companyData) {
      state.selectedCompanyData = companyData
    },
    [at.SET_ACTIVE_COMPANY_DATA_LOADING](state, isLoading) {
      state.selectedCompanyLoading = isLoading
    },
    [at.SET_ACTIVE_EXPORTS](state, exports) {
      state.activeExports = exports
    },
    [at.ADD_EXPORT](state, exportData) {
      state.activeExports.push(exportData)
      localStorage.setItem('activeExports', JSON.stringify(state.activeExports))
    },
    [at.CLEAR_EXPORT_QUEUE](state) {
      state.activeExports = []
      localStorage.setItem('activeExports', JSON.stringify(state.activeExports))
    },
    [at.SET_WSS_CONNECTION](state, wss) {
      state.wss = wss
    },
    [at.LOAD_USER_DATA](state, userData) {
      state.user.data = userData
      state.user.isLoggedIn = true
    },
    [at.UPDATE_USER_DATA](state, newUserData) {
      state.user.data = {
        ...state.user.data,
        ...newUserData,
      }
    },
    [at.SUBSCRIBED_TO_WSS_CHANNEL](state, channel) {
      state.subscribedWssChannels.push(channel)
    },
    [at.UPDATE_EXPORT_ITEM](state, exportItemData) {
      let exportItemIndex = state.activeExports.findIndex(
        (_export) => _export.report_uuid === exportItemData.report_uuid
      )

      if (exportItemIndex === -1) {
        return
      }

      state.activeExports.splice(exportItemIndex, 1, {
        ...state.activeExports[exportItemIndex],
        report_status_slug: exportItemData.report_status_slug,
      })
    },
    [at.EXPORT_DOWNLOADED](state, exportUUID) {
      let exportItemIndex = state.activeExports.findIndex(
        (_export) => _export.report_uuid === exportUUID
      )

      if (exportItemIndex === -1) {
        return
      }

      state.activeExports.splice(exportItemIndex, 1)
      localStorage.setItem('activeExports', JSON.stringify(state.activeExports))
    },
    [at.LOAD_USER_COMPANY_RULES](state, payload) {
      state.isRulesLoaded = payload.isLoaded
      state.rulesLoadedForCompany = payload.companyId
    },
    [at.RESET_PASSWORD_STEP](state, payload) {
      state.appState.resetPasswordState = {
        ...(state.appState.resetPasswordState || {}),
        payload,
      }
    },
    HIDE_CABINET_BOTTOM_NOTICE(state) {
      state.showCabinetBottomNotice = false;
    },
    SET_COMPANIES(state, companies) {
      state.companies = companies
      state.companiesLoaded = true
    },
  },
  actions: {
    async LOAD_COMPANIES({ commit, state }) {
      if (state.companiesLoaded) {
        return
      }

      try {
        const response = await CompaniesApi.getCompanies()
        commit('SET_COMPANIES', response.data)
      } catch (e) {
        console.error('Failed to load companies', e)
        throw e
      }
    },

    async [at.INITIALIZE_AUTH]({ commit, dispatch }) {
      const accessToken = localStorage.getItem('accessToken')
      const refreshToken = localStorage.getItem('refreshToken')

      if (accessToken && refreshToken) {
        commit(at.LOGIN_USER, {
          accessToken,
          refreshToken
        });
        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
        await dispatch(at.LOAD_USER_DATA)

        return true;
      }
      return false;
    },

    setXpayOperationType({ commit }, value) {
      commit(at.SET_XPAY_OPERATION_TYPE, value)
    },
    setXpayOperationId({ commit }, value) {
      commit(at.SET_XPAY_OPERATION_ID, value)
    },
    setShowFilters({ commit }, value) {
      commit(at.SET_SHOW_FILTERS, value)
    },
    async [at.LOGIN_USER]({ commit, dispatch }, payload) {
      localStorage.setItem('accessToken', payload.accessToken)
      localStorage.setItem('phone', payload.phone)
      localStorage.setItem('refreshToken', payload.refreshToken)

      axiosInstance.defaults.headers.common[
        'Authorization'
      ] = `Bearer ${payload.accessToken}`

      commit(at.LOGIN_USER, payload)
      await dispatch(at.LOAD_USER_DATA)
    },
    [at.UPDATE_TOKENS]({ commit }, tokens) {
      localStorage.setItem('accessToken', tokens.accessToken)
      localStorage.setItem('refreshToken', tokens.refreshToken)
      axiosInstance.defaults.headers.common[
        'Authorization'
      ] = `Bearer ${tokens.accessToken}`

      commit(at.UPDATE_TOKENS, tokens)
    },
    [at.LOGOUT_USER]({ commit }) {
      localStorage.setItem('accessToken', '')
      localStorage.setItem('username', '')
      localStorage.setItem('phone', '')

      delete axiosInstance.defaults.headers.common['Authorization']
      commit(at.LOGOUT_USER)
    },
    [at.SET_CURRENT_LOCALE]({ commit }, locale) {
      localStorage.setItem('selectedLocale', locale)
      commit(at.SET_CURRENT_LOCALE, locale)
    },
    [at.SET_ACTIVE_COMPANY]({ commit }, selectedCompanyId) {
      commit(at.SET_ACTIVE_COMPANY, selectedCompanyId)
    },
    [at.SET_ACTIVE_COMPANY_DATA]({ commit }, companyData) {
      commit(at.SET_ACTIVE_COMPANY_DATA, companyData)
    },
    [at.ADD_EXPORT]({ commit, getters }, exportData) {
      if (getters.exportExisted(exportData.section, exportData.filterString)) {
        return
      }

      commit(at.ADD_EXPORT, { ...exportData, downloaded: false })
    },
    [at.SET_WSS_CONNECTION]({ commit }, wss) {
      commit(at.SET_WSS_CONNECTION, wss)
    },
    async [at.LOAD_USER_DATA]({ commit }) {
      try {
        let _userResponse = await UserApi.me()

        commit(at.LOAD_USER_DATA, _userResponse.data)

        let _activeExports = localStorage.getItem('activeExports')
        if (_activeExports) {
          commit(at.SET_ACTIVE_EXPORTS, JSON.parse(_activeExports))
        }
      } catch (e) {}
    },
    [at.SUBSCRIBE_TO_REPORT_CHANNEL](
      { state, commit, dispatch },
      reportChannel
    ) {
      const wssSubscription = state.wss.newSubscription(reportChannel)
      wssSubscription.on('publication', (ctx) => {
        dispatch(at.HANDLE_EXPORT_WS_MESSAGE, ctx.data)
      })
      wssSubscription.subscribe()

      commit(at.SUBSCRIBED_TO_WSS_CHANNEL, wssSubscription)
    },
    async [at.HANDLE_EXPORT_WS_MESSAGE](
        { state, getters, commit, dispatch },
        wsMessage
    ) {
      console.log('--- [WSS Message Received] ---', wsMessage);

      // Небольшая задержка, как в вашем коде
      await new Promise((r) => setTimeout(r, 2000));

      // 1. Проверяем обновление стейта
      commit(at.UPDATE_EXPORT_ITEM, wsMessage);
      console.log('[WSS] State updated for UUID:', wsMessage.report_uuid);

      // 2. Ищем объект экспорта в стейте
      let _export = getters.exportByUUID(wsMessage.report_uuid);
      console.log('[WSS] Found export in store:', _export);

      if (!_export) {
        console.error('[WSS] Error: Export item not found in store by UUID');
        return;
      }

      // 3. Проверяем статус
      console.log('[WSS] Current status:', _export.report_status_slug);
      if (_export.report_status_slug !== 'complete') {
        console.warn('[WSS] Export is not complete yet. Skipping download.');
        return;
      }

      // 4. Логируем начало загрузки
      let reportExt = _export.file_type_slug === 'csv' ? 'csv' : 'xls';
      console.log(`[API] Starting file download: ${_export.report_uuid}.${reportExt}`);

      try {
        let _analyticsExportDownloadResponse = await ExportApi.downloadExportFile(
            _export.report_uuid,
            _export.file_type_slug
        );

        console.log('[API] Download response received:', _analyticsExportDownloadResponse);

        // 5. Проверка данных блоба
        if (!_analyticsExportDownloadResponse.data) {
          console.error('[API] Download failed: No data in response');
          return;
        }

        // Вызываем функцию скачивания
        downloadBlob(
            _analyticsExportDownloadResponse.data,
            `${_export.report_uuid}.${reportExt}`
        );
        console.log('[UI] downloadBlob called successfully');

        setTimeout(() => {
          commit(at.EXPORT_DOWNLOADED, _export.report_uuid);
          console.log('[WSS] Export item removed from active list');
        }, 2000);

      } catch (error) {
        console.error('[API] Critical error during export download:', error);
      }
    },
    // async [at.HANDLE_EXPORT_WS_MESSAGE](
    //   { state, getters, commit, dispatch },
    //   wsMessage
    // ) {
    //   await new Promise((r) => setTimeout(r, 2000))
    //
    //   commit(at.UPDATE_EXPORT_ITEM, wsMessage)
    //
    //   let _export = getters.exportByUUID(wsMessage.report_uuid)
    //
    //   if (!_export || _export.report_status_slug !== 'complete') {
    //     return
    //   }
    //
    //   let reportExt = 'xls'
    //
    //   switch (_export.file_type_slug) {
    //     case 'csv':
    //       reportExt = 'csv'
    //       break
    //   }
    //
    //   let _analyticsExportDownloadResponse = await ExportApi.downloadExportFile(
    //     _export.report_uuid,
    //     _export.file_type_slug
    //   )
    //
    //   downloadBlob(
    //     _analyticsExportDownloadResponse.data,
    //     `${_export.report_uuid}.${reportExt}`
    //   )
    //
    //   setTimeout(() => {
    //     commit(at.EXPORT_DOWNLOADED, _export.report_uuid)
    //   }, 2000)
    // },
    [at.UPDATE_EXPORT_ITEM]({ commit }, exportItemData) {
      commit(at.UPDATE_EXPORT_ITEM, {
        report_uuid: exportItemData.report_uuid,
        report_status_slug: exportItemData.report_status_slug,
      })
    },
    async [at.SYNC_EXPORTS]({ dispatch, state }) {
      if (state.activeExports.length === 0) {
        return
      }

      let _allExports = (await ExportApi.getAll()).data.reports

      state.activeExports.forEach((_export) => {
        let _allExportsIndex = _allExports.findIndex(
          (_e) => _export.report_uuid === _e.report_uuid
        )

        if (!_allExportsIndex) {
          return
        }

        dispatch(at.HANDLE_EXPORT_WS_MESSAGE, _allExports[_allExportsIndex])
      })
    },
    async [at.LOAD_USER_COMPANY_RULES]({ commit }, companyId) {
      commit(at.LOAD_USER_COMPANY_RULES, {
        isLoaded: false,
        companyId: null,
      })

      try {
        await authorizer.setUser(companyId)
      } catch (e) {
        console.error('ACL load error:', e)

        if (authorizer.reset) {
          authorizer.reset()
        } else {
          authorizer.setRules([])
        }

        commit(at.LOAD_USER_COMPANY_RULES, { isLoaded: true, companyId })
      }

      commit(at.LOAD_USER_COMPANY_RULES, {
        isLoaded: true,
        companyId: companyId,
      })
    },
    async [at.LOAD_COMPANY]({ commit, dispatch }, companyId) {
      commit(at.SET_ACTIVE_COMPANY_DATA_LOADING, true)

      let companyResponse = await CompaniesApi.getCompanyDashboard(companyId)
      await dispatch(at.SET_ACTIVE_COMPANY_DATA, companyResponse.data)

      await dispatch(at.LOAD_USER_COMPANY_RULES, companyId)

      await dispatch(at.SET_ACTIVE_COMPANY, companyId)
      commit(at.SET_ACTIVE_COMPANY_DATA_LOADING, false)
    },
    [at.RESET_PASSWORD_STEP]({ commit, state }, resetPasswordData) {
      commit(at.RESET_PASSWORD_STEP, resetPasswordData)
      localStorage.setItem(
        'resetPasswordData',
        JSON.stringify(resetPasswordData)
      )
    },
  },
  modules: {},
})
